export const HELP_CENTER_DATA = [
  {
    title: 'About this Subscription',
    content:
      'Help systems should be conveniently accessible in locations where users can possibly need answers to their questions, e.g., when they get started using a website, and when they could benefit from useful information.',
  },
  {
    title: 'Getting Started',
    content:
      'For a help system to be effective, you must spend time in information architecture. Have a small number of main categories, each of which can have sub-categories. ',
  },
  {
    title: 'Contact',
    content:
      'This Contact Us page does two things well: it asks for only the information that is necessary (email address) and it displays a video that explains exactly how contacting the IMPACT team works.',
  },
  {
    title: 'Frequesntly Asked Questions (FAQs)',
    content:
      'Frequently Asked Question (FAQ) pages (or informational hubs) enable your business to respond, react, and anticipate the needs of your audience more quickly and appropriately than other types of destination page experiences.',
  },
  {
    title: 'Get Support',
    content: 'We are here to help and answer any question you might have. We look forward to hearing from you.',
  },
  {
    title: 'Manage Your Account',
    content:
      'Everything you need to know about account settings and profile page. Engage your contacts using the best mobile-friendly email design tools.',
  },
]
